import React, { useEffect, useState } from "react";
import { PageHeaderUi } from "../../ui/PageHeaderUi";
import { ButtonUi } from "../../ui/ButtonUi";
import { TipoButtonConstants } from "../../../types/typesConstants";
import { Col, Row } from "antd";
import { MovimientoSearchForm } from "./MovimientoSearchForm";
import { MovimientosTable } from "./MovimientosTable";
import { useDispatch, useSelector } from "react-redux";
import { MovimientoEntradaScreen } from "./entrada/MovimientoEntradaScreen";
import { comprobanteMovimientoStartLoading } from "../../../actions/inventario";
import { MovimientoSalidaScreen } from "./salida/MovimientoSalidaScreen";
import { nowDateFormatBackEnd } from "../../../helpers/utils";

export const MovimientosListScreen = ({
  onOpenInputForm,
  onOpenOutputForm,
}) => {
  const { loading } = useSelector((state) => state.ui);
  const { comprobantesMovimiento, paginator } = useSelector(
    (state) => state.inventario,
  );

  return (
    <PageHeaderUi
      title="Movimientos"
      subTitle="Listado"
      extra={[
        <ButtonUi
          key="ingreso"
          typeUi={TipoButtonConstants.Agregar}
          text="Ingreso"
          onClick={onOpenInputForm}
        />,
        <ButtonUi
          key="salida"
          typeUi={TipoButtonConstants.Disminuir}
          text="Salida"
          onClick={onOpenOutputForm}
        />,
      ]}
    >
      <Row gutter={{ xs: 8, sm: 16, md: 24, lg: 32 }}>
        <Col span={24}>
          <MovimientoSearchForm />
        </Col>
      </Row>
      <Row gutter={{ xs: 8, sm: 16, md: 24, lg: 32 }}>
        <Col xs={24} sm={24} md={24} lg={24} xl={24}>
          <MovimientosTable
            data={comprobantesMovimiento}
            loading={loading}
            paginator={paginator}
          />
        </Col>
      </Row>
    </PageHeaderUi>
  );
};

export const MovimientosList = () => {
  const [openInputForm, setOpenInputForm] = useState(false);
  const [openOutputForm, setOpenOutputForm] = useState(false);
  const dispatch = useDispatch();
  useEffect(() => {
    const nowDate = nowDateFormatBackEnd();
    dispatch(
      comprobanteMovimientoStartLoading({
        fechaemision: `${nowDate}|${nowDate}`,
      }),
    );
  }, []);
  const handleOpenInputForm = () => setOpenInputForm(true);
  const handleCloseInputForm = () => setOpenInputForm(false);
  const handleOpenOutputForm = () => setOpenOutputForm(true);
  const handleCloseOutputForm = () => setOpenOutputForm(false);
  if (openInputForm) {
    return <MovimientoEntradaScreen onClose={handleCloseInputForm} />;
  } else if (openOutputForm) {
    return <MovimientoSalidaScreen onClose={handleCloseOutputForm} />;
  } else {
    return (
      <MovimientosListScreen
        onOpenInputForm={handleOpenInputForm}
        onOpenOutputForm={handleOpenOutputForm}
      />
    );
  }
};
